import { ApiService } from './api.service';
import { SchoolGroup } from '@/models/school-group/school-group';
import { CompetencySetting } from '@/models/competency/competency-setting';
import { SchoolGroupCompetencyRanking } from '@/models/school-group/school-group-competency-ranking';
import { CompetencyRankingSettingRequest } from '@/models/competency/competency-ranking-setting-request';

class SchoolGroupService extends ApiService {
  constructor() {
    super();
  }

  getSchoolGroups(targetType: number = 0, targetID: number = 0, selectedCommaTagIDs: string = ''): Promise<SchoolGroup[]> {
    return this.getList(SchoolGroup, 'schoolGroups', {
      targetType,
      targetID,
      tagIDs: selectedCommaTagIDs,
    });
  }

  getCompetencySetting(targetType: number = 1, targetID: number = 1): Promise<CompetencySetting[]> {
    return this.getList(CompetencySetting, 'schoolGroups/competencySetting', { targetType, targetID });
  }

  getCompetencyRanking(targetType: number = 1, targetID: number = 1, tagIDs: string = ''): Promise<SchoolGroupCompetencyRanking[]> {
    return this.getList(SchoolGroupCompetencyRanking, 'schoolGroups/competencyRanking', {
      targetType,
      targetID,
      tagIDs,
    });
  }

  putCompetencySetting(params: CompetencyRankingSettingRequest): Promise<CompetencySetting> {
    return this.put(CompetencySetting, 'schoolGroups/competencySetting', params);
  }
}

export const schoolGroupService = new SchoolGroupService();
